exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fade-in.ng-hide-remove{transition:opacity 1s linear;opacity:0}.fade-in.ng-hide-remove-active{opacity:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/main/webapp-files/styles/animations.less
// module id = 29
// module chunks = 0